import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectShouldUseSpeedyGroove = createBasicSelector(state =>
  selectBooleanPreferenceByName(state, 'speedy_groove')
)
